import request from '@/utils/request'

//取得人工尚未驗證的人數
export function getManuallyCount() {
  return request({
    url: '/ToursCombineSetting/getManuallyCount',
    method: 'get',
  })
}

export function getLeaderLicense(data) {
  return request({
    url: '/ToursCombineSetting/getLeaderLicense',
    method: 'post',
    data,
  })
}

export function saveType(data) {
  return request({
    url: '/ToursCombineSetting/saveToursCombineType',
    method: 'post',
    data,
  })
}

export function getType() {
  return request({
    url: '/ToursCombineSetting/getToursCombineType',
    method: 'get',
  })
}

export function deleteType(data) {
  return request({
    url: '/ToursCombineSetting/deleteToursCombineType',
    method: 'post',
    data,
  })
}

export function saveItem(data) {
  return request({
    url: '/ToursCombineSetting/saveToursCombineItem',
    method: 'post',
    data,
  })
}

export function getItemOfType(query) {
  return request({
    url: '/ToursCombineSetting/getToursCombineItemOfType',
    method: 'get',
    params: query,
  })
}

export function deleteItem(data) {
  return request({
    url: '/ToursCombineSetting/deleteToursCombineItem',
    method: 'post',
    data,
  })
}

export function saveHashTag(data) {
  return request({
    url: '/ToursCombineSetting/saveToursCombineHashTag',
    method: 'post',
    data,
  })
}

//saveHashTagStringList
export function saveHashTagFromArticle(data) {
  return request({
    url: '/ToursCombineSetting/saveToursCombineHashTagString',
    method: 'post',
    data,
  })
}

export function getHashTag(data) {
  return request({
    url: '/ToursCombineSetting/getToursCombineHashTag',
    method: 'post',
    data,
  })
}

export function getHashTagList(query) {
  return request({
    url: '/ToursCombineSetting/getToursCombineHashTagList',
    method: 'get',
    params: query,
  })
}

export function getHashTagSelectList() {
  return request({
    url: '/ToursCombineSetting/getHashTagSelectList',
    method: 'get',
  })
}

export function deleteHashTag(data) {
  return request({
    url: '/ToursCombineSetting/deleteToursCombineHashTag',
    method: 'post',
    data,
  })
}

export function getHashTagSearch(id) {
  return request({
    url: '/ToursCombineSetting/getHashTagSearch/' + id,
    method: 'get',
  })
}

export function saveArticle(data) {
  return request({
    url: '/ToursCombineSetting/saveToursCombineArticle',
    method: 'post',
    data,
  })
}

export function getArticle(data) {
  return request({
    url: '/ToursCombineSetting/getToursCombineArticle',
    method: 'post',
    data,
  })
}

export function getArticleContent(id) {
  return request({
    url: '/ToursCombineSetting/getToursCombineArticleContent/' + id,
    method: 'get',
  })
}

export function saveArticleContentImage(data) {
  return request({
    url: '/ToursCombineSetting/saveToursCombineArticleContentImage',
    method: 'post',
    data,
  })
}

export function deleteArticle(data) {
  return request({
    url: '/ToursCombineSetting/deleteToursCombineArticle',
    method: 'post',
    data,
  })
}

export function getArticleIntroductionList(data) {
  return request({
    url: '/ToursCombineSetting/getArticleIntroductionSelectList',
    method: 'post',
    data,
  })
}

export function getIntroductionList(data) {
  return request({
    url: '/ToursCombineSetting/getIntroductionList',
    method: 'post',
    data,
  })
}

export function getIntroduction(id) {
  return request({
    url: '/ToursCombineSetting/getIntroduction/' + id,
    method: 'get',
  })
}

export function getIntroductionByEmail(data) {
  return request({
    url: '/ToursCombineSetting/getIntroduction',
    method: 'post',
    data,
  })
}

export function getIntroductionTypeList() {
  return request({
    url: '/ToursCombineSetting/getIntroductionTypeSelectList',
    method: 'get',
  })
}

export function saveIntroduction(data) {
  return request({
    url: '/ToursCombineSetting/saveIntroduction',
    method: 'post',
    data,
  })
}

export function deleteIntroduction(data) {
  return request({
    url: '/ToursCombineSetting/deleteIntroduction',
    method: 'post',
    data,
  })
}

export function getIndexCarousel() {
  return request({
    url: '/ToursCombineSetting/getIndexCarousel',
    method: 'get',
  })
}

export function saveIndexCarousel(data) {
  return request({
    url: '/ToursCombineSetting/saveIndexCarousel',
    method: 'post',
    data,
  })
}

export function deleteIndexCarousel(data) {
  return request({
    url: '/ToursCombineSetting/deleteIndexCarousel',
    method: 'post',
    data,
  })
}

export function getHashTagGather() {
  return request({
    url: '/ToursCombineSetting/getHashTagGather',
    method: 'get',
  })
}

export function saveHashTagGather(data) {
  return request({
    url: '/ToursCombineSetting/saveHashTagGather',
    method: 'post',
    data,
  })
}

export function deleteHashTagGather(data) {
  return request({
    url: '/ToursCombineSetting/deleteHashTagGather',
    method: 'post',
    data,
  })
}

export function saveCountrySort(data) {
  return request({
    url: '/TravelSettings/saveTravelAttractionsCascaderMenu',
    method: 'post',
    data,
  })
}

export function getHotCountry() {
  return request({
    url: '/ToursCombineSetting/getHotCountry',
    method: 'get',
  })
}

export function saveHotCountry(data) {
  return request({
    url: '/ToursCombineSetting/saveHotCountry',
    method: 'post',
    data,
  })
}

export function deleteHotCountry(data) {
  return request({
    url: '/ToursCombineSetting/deleteHotCountry',
    method: 'post',
    data,
  })
}

export function deleteDescription(data) {
  return request({
    url: '/ToursCombineSetting/deleteDescription',
    method: 'post',
    data,
  })
}

export function saveDescription(data) {
  return request({
    url: '/ToursCombineSetting/saveDescription',
    method: 'post',
    data,
  })
}

export function getDescription() {
  return request({
    url: '/ToursCombineSetting/getDescription',
    method: 'get',
  })
}

export function getSettingDescriptionTypeList() {
  return request({
    url: '/ToursCombineSetting/getSettingDescriptionTypeList',
    method: 'get',
  })
}

export function saveLeaderLicense(data) {
  return request({
    url: '/ToursCombineSetting/saveLeaderLicense',
    method: 'post',
    data,
  })
}

export function getBloggerApplication(data) {
  return request({
    url: '/ToursCombineSetting/getBloggerApplication',
    method: 'post',
    data,
  })
}

export function checkEmail(data) {
  return request({
    url: '/ToursCombineSetting/checkEmail',
    method: 'post',
    data,
  })
}

export function saveVerifyData(data) {
  return request({
    url: '/ToursCombineSetting/saveVerifyData',
    method: 'post',
    data,
  })
}

export function deleteBloggerApplication(data) {
  return request({
    url: '/ToursCombineSetting/deleteBloggerApplication',
    method: 'post',
    data,
  })
}

export function sendEmail(data) {
  return request({
    url: '/ToursCombineSetting/sendEmail',
    method: 'post',
    data,
  })
}

export function verifyLeader(data) {
  return request({
    url: '/ToursCombineSetting/verifyLeader',
    method: 'post',
    data,
  })
}

export function getComments(data) {
  return request({
    url: '/ToursCombineSetting/getComments',
    method: 'post',
    data,
  })
}

export function deleteComment(data) {
  return request({
    url: '/ToursCombineSetting/deleteComment',
    method: 'post',
    data,
  })
}

export function getCommentBlackList(data) {
  return request({
    url: '/ToursCombineSetting/getCommentBlackList',
    method: 'post',
    data,
  })
}

export function saveCommentBlackList(data) {
  return request({
    url: '/ToursCombineSetting/saveCommentBlackList',
    method: 'post',
    data,
  })
}

/**
 * 取得通用編輯頁
 * @param {string} type
 * type TravelPlan 旅行團行程(天)
 * type TravelNotes 旅行團行程注意事項
 */
export function getEditPage(type, query) {
  return request({
    url: `/ToursCombineSetting/getEditPage/${type}`,
    method: 'get',
    params: query,
  })
}

// 修改通用編輯頁
export function saveEditPage(data) {
  return request({
    url: '/ToursCombineSetting/saveEditPage',
    method: 'post',
    data,
  })
}

// 取得不雅文字列表
export function getAdultTextBlocking() {
  return request({
    url: '/ToursCombineSetting/getAdultTextBlocking',
    method: 'get'
  })
}

// 儲存不雅文字列表
export function saveAdultTextBlocking(data) {
  return request({
    url: '/ToursCombineSetting/saveAdultTextBlocking',
    method: 'post',
    data,
  })
}
